<div class="header-container w-full flex items-center">
    <app-logo></app-logo><app-projects-header class="flex-1"></app-projects-header>
</div>
